import styles from "./requests.module.css";
import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

import { Flex, Typography, Card, App } from "antd";
import Breadcrumbs from "@/components/ui/Breadcrumbs";

import CopyableText from "@/components/ui/СopyableText";
import { getFormItem } from "@/api/requests";

import routes from "@/routes";

const { Title, Text } = Typography;

const Requests = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { message } = App.useApp();

  const [requestType, setRequestType] = useState({});
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    setLoading(true);
    let shouldKeepLoading = false;

    try {
      const requestType = await getFormItem({ uuid: uuid }, false);
      const units = requestType?.units || [];
      const isPublic = requestType?.access_mode === "public";

      if (units.length === 1) {
        shouldKeepLoading = true;
        navigate(routes.requestForm(uuid, units[0].unit_uuid, isPublic), {
          replace: true,
        });
        return;
      }

      setRequestType(requestType);
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      if (!shouldKeepLoading) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, [uuid]);

  return (
    <>
      <Flex vertical gap={20}>
        <Flex vertical gap={10}>
          <Breadcrumbs
            items={[
              {
                title: "Главная",
                href: routes.dashboards,
              },
              {
                title: "Заявки",
              },
              {
                title: requestType?.name || "Заявка",
              },
            ]}
          />

          <Title level={2} className="no-margin">
            {requestType?.name || "Заявка"}
          </Title>
        </Flex>

        <Card loading={loading}>
          {!!requestType?.units?.length ? (
            <Flex vertical align="flex-start" gap={10}>
              {requestType.units.map((unit) => {
                const isPublic = requestType.access_mode === "public";
                const path = routes.requestForm(
                  uuid,
                  unit.unit_uuid,
                  isPublic,
                );

                const link = (
                  <Link
                    key={unit.unit_uuid}
                    className={styles.link}
                    to={path}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(path, "_blank", "noopener,noreferrer");
                    }}
                  >
                    {unit.unit_name}
                  </Link>
                );

                return isPublic ? (
                  <CopyableText
                    key={unit.unit_uuid}
                    text={`${window.location.origin}${path}`}
                  >
                    {link}
                  </CopyableText>
                ) : (
                  link
                );
              })}
            </Flex>
          ) : (
            <Text type="secondary">Нет рабочих групп</Text>
          )}
        </Card>
      </Flex>
    </>
  );
};

export default Requests;
